
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/independent-travel-agent",
      function () {
        return require("private-next-pages/independent-travel-agent/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/independent-travel-agent"])
      });
    }
  